/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { operations, OPERATION_LABEL } from '../constants';
import { addUrlParams } from '../utils';
import { SegmentedControl } from './ui';

const OperationsTab = ({ onChange, activeValue, operationKeys }) => {
  const [period, setPeriod] = useState(activeValue);
  const operationEntries =
    operationKeys && operationKeys.length > 0
      ? operationKeys
          .filter(key => Object.prototype.hasOwnProperty.call(operations, key))
          .map(key => [key, operations[key]])
      : Object.entries(operations);

  const handleButtonClick = value => {
    addUrlParams('operation', value);
    setPeriod(value);
    onChange(value);
  };

  useEffect(() => {
    setPeriod(activeValue);
  }, [activeValue]);

  return (
    <SegmentedControl
      items={operationEntries.map(([key, value]) => ({
        value,
        label: OPERATION_LABEL[key]
      }))}
      value={period}
      onChange={handleButtonClick}
    />
  );
};

export default OperationsTab;
